export default {
  options: {
    units: {
      kilometers: 'kilometri',
      meters: 'metri',
      miles: 'mile',
    },
    areUnits: {
      sqKms: 'km²',
      hectare: 'hectare',
      sqMeters: 'm²',
    },
  }
}
